import defaultTexts from '../assets/default-texts.js';

class ThemeManager {

	constructor(merchantId, theme) {
		this.merchantId = merchantId;
		this.theme = theme;
	}

	value(moduleName, key, rootFallbackKey) {
		return this.getForMerchant(this.merchantId, this.theme, moduleName, key, rootFallbackKey);
	}

	valueOrDefault(moduleName, key, rootFallbackKey, defaultVal) {
		const value =
			this.getForMerchant(this.merchantId, this.theme, moduleName, key, rootFallbackKey);
		if (value == null) return defaultVal;
		return value;
	}

	getIntOrNullFromTheme(moduleName, key, rootFallbackKey) {
		const value = this.getForMerchant(this.merchantId, this.theme, moduleName, key, rootFallbackKey);
		if (!value) {
			return null;
		} else if (/^\d+$/.test(value)) { // Validate it's an integer
			return parseInt(value, 10);
		}
		console.error('Configured theme value is not an integer!', moduleName, key);
		return null;
	}

	getForMerchant(merchantId, theme, moduleName, key, rootFallbackKey) {
		let value = null;
		if (theme && theme.modules && theme.modules[moduleName] && theme.modules[moduleName][key]) {
			value = theme.modules[moduleName][key];
		} else if (theme && theme.root && theme.root[rootFallbackKey]) {
			value = theme.root[rootFallbackKey];
		}
		return value;
	}

	getThemeText(key) {
		let value = '';
		if (this.theme && this.theme.texts && this.theme.texts[key]) {
			value = this.theme.texts[key];
		}
		return value;
	}

	getCheckoutPriceLegalNoteOrDefault() {
		const checkoutPriceLegalNote = this.theme.texts.checkoutPriceLegalNote;
		if (checkoutPriceLegalNote) {
			return checkoutPriceLegalNote;
		}
		return 'Preise inkl. MwSt. und ggf. Versandgebühren';
	}

	getThemeTextOrHardcodedDefault(key) {
		let text = this.theme.texts[key];
		if (text) {
			return text;
		}

		text = defaultTexts[key];
		if (text) {
			return text;
		}

		return '';
	}
}

export default ThemeManager;

